var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-list"},[_vm._l((_vm.list),function(item,index){return [_c('PayListItem',{key:index,attrs:{"item":item,"active":index === _vm.itemIndex},nativeOn:{"click":function($event){return _vm.click(index)}}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }